export default {
    adminRegister: "GET /auth/admin/register",
    //管理员虚拟币信息
    currencyCountOfAdmin: "POST /api/currency/countOfAdmin",
    //功能组
    funcGroupList: "/api/func/group/list",
    //获取管理员加入的功能组详情列表
    apiAdminJoinFuncGroup: 'GET /api/user/admin/joinFuncGroup',
    //获取终端加入的功能组详情列表
    apiUserJoinFuncGroup: 'GET /api/user/ptt/joinFuncGroup',
    //管理员续费
    apiAdminRenewByCurrency: 'POST /api/user/admin/renewByCurrency',
    //查找登录账号信息
    adminFindLoginName: "/api/user/admin/find/login_name",
    //管理员添加
    adminUpdate: "POST /api/user/admin/update",
    //管理员添加
    adminAdd2: "POST /api/user/admin/add2",
    adminAdd: "POST /api/user/admin/add",
    //用户虚拟币数
    currencyCountOfAdmin: "POST /api/currency/countOfAdmin",
    //获取管理员列表
    adminList: "POST /api/user/admin/list",
    //下发额度
    currencyGrant: '/api/currency/grant',
    //回收虚拟币
    currencyRetrieve: '/api/currency/retrieve',
    //获取用户的群组
    userPttGroups: "POST /api/user/ptt/groups",
    //获取额度用户列表
    adminQuotaList: "POST /api/quota/list",
    //获取虚拟币操作记录
    adminCurrencyRecordList: "POST /api/currency/record/list",
    //用户可用续费币数
    currencyRenewSurlpusCount: "/api/currency/renewSurlpusCount",
    //用户可用行业币数
    currencyTradeSurlpusCount: "/api/currency/tradeSurlpusCount",
    //用户虚拟币续费
    apiUserRenewByCurrency: "POST /api/user/ptt/renewByCurrency",
    //用户续费币续费
    apiUserRenewByRenewCurrency: "POST /api/user/ptt/renewByRenewCurrency",
    // 批量续费
    apiBatchRenewByCurrency: 'POST /api/user/ptt/renewBatchByCurrency',
    //用户设置功能权限
    apiUserPttSetFunctions: 'POST /api/user/ptt/functions/set',
    //用户设置功能权限 (支持续费)
    apiUserPttSetFunctionsV2: 'POST /api/user/ptt/functions/set/v2',
    //查询功能权限
    apiuserPttGetFunctions: '/api/user/ptt/functions/get',
    //查询行业功能组
    apiuserPttGetFuncGroupList: '/api/func/trade_group/list',
    //查询账号信息
    apiuserPttGetUserInfo: '/api/user/ptt/find2/id',

    //获取管理员所有的权限
    apiAdminAllPermissions: "/api/admin/permission/list",
    //获取管理员的权限
    apiAdminPermissionsById: "/api/admin/permission/find/adminId",
    //设置管理员的权限
    apiSetAdminPermissionsById: "POST /api/admin/permission/set",
    //管理员分配功能组列表
    adminAllocationFunctionGrp: 'POST /api/user/admin/allocation/fgrp',
    //设置管理员优惠月数
    adminSetPreferentialMonth: '/api/user/admin/preferentialMonths/set',
    //获取管理员分配功能组列表
    adminAssignFuncGroup: '/api/user/admin/allocation/info/get',
    //打卡记录
    punchingAardRecord: 'api/patrol/point/list/record',
    //打卡成功
    ClockInSuccess: 'api/patrol/point/punch_in/success',
    //打卡失败
    PunchingFailure: 'api/patrol/point/punch_in/failure',
    //回收管理员列表
    adminRetrieveList: 'POST /api/user/admin/list/retrieve',

    //查询币 可根据传的类型来查询对应管理员不同的币
    userCurrencyCount: '/api/currency/surlpusCount',

  /**
   * 企业管理模块
   */
  // 企业管理员查询
  apiEnterpriseAdminGetList: 'POST /api/enterprise/admin/page',
  // 企业管理员添加
  apiEnterpriseAddAdmin: 'POST /api/enterprise/admin/create',

  // 企业账号查询
  apiEnterpriseUsersGetList: 'POST /api/enterprise/user/page',
  // 企业账号添加
  apiEnterpriseAddUser: 'POST /api/enterprise/user/create',
  // 企业账号删除
  apiEnterpriseDelUser: 'POST /api/enterprise/user/delete',
  // 企业账号修改
  apiEnterpriseUpdateUser: 'POST /api/enterprise/user/update',
  // 激活 企业账号
  apiEnterpriseUserActivation: 'POST /api/enterprise/user/activation',
  // 暂停 企业账号
  apiEnterpriseUserSuspend: 'POST /api/enterprise/user/suspend',
  // 批量续费 企业账号
  apiEnterpriseBatchRenew: 'POST /api/enterprise/user/renewBatchByCurrency',
  // 企业账号IMEI 放号
  apiEnterpriseImeiRemotr: 'POST /api/enterprise/user/write_account',


  // 企业群组查询
  apiEnterpriseGroupsGetList: 'POST /api/enterprise/group/page',
  // 企业群组添加
  apiEnterpriseAddGroup: 'POST /api/enterprise/group/create',
  // 企业群组修改
  apiEnterpriseUpdateGroup: 'POST /api/enterprise/group/update',
  // 企业群组名称批量修改
  apiEnterpriseUpdateGroupName: 'POST /api/enterprise/group/name/update',
  // 删除企业群组
  apiEnterpriseDelGroup: 'POST /api/enterprise/group/delete',
  // 修改群组成员优先级
  apiEnterPriseGroupUserPriority: 'POST /api/enterprise/group/members_priority/set'

};
